var errorTypes = {
  LOADING_PROCESSING_SETTINGS: 'loadingSettingsError',
  SAVE_PROCESSING_SETTINGS: 'saveSettingsError'
};
export default errorTypes;